export class SignatoryOrder {
  id: number;
  order: number;
  name: string;
  mail: string;
  disabled: boolean;
}
